<template>
    <b-card no-body>
        <b-card-header class="title-display">
            <span class="title-one">Assurances Of Compliance</span>
        </b-card-header>
        <b-card-body>
            <b-form>
                <b-form-row>
                    <PerkinsStatementOfAssurances />
                </b-form-row>
                <br>
                <b-container>
                    <b-card no-body border-variant="primary">
                        <b-card-header
                            header-class="perkins-coordinator-card"
                            header-bg-variant="primary"
                            header-text-variant="white"
                        >
                            <b-row align-h="center">
                                <b-col>
                                    Perkins Coordinator
                                </b-col>
                            </b-row>
                        </b-card-header>
                        <b-card-body>
                            <b-form-row>
                                <b-col>
                                    <b-form-group
                                        id="coordinator-name-group"
                                        label="Name:"
                                        label-for="coordinator-name-input"
                                        label-cols-sm="2"
                                        label-align-sm="right"
                                        :invalid-feedback="invalidNameFeedback"
                                        :state="nameState"
                                        :disabled="!showSaveCoordinatorButton"
                                    >
                                        <b-form-input
                                            id="coordinator-name-input"
                                            v-model="coordinatorName"
                                            type="text"
                                            required
                                            placeholder="Enter first and last names of Perkins Coordinator"
                                            :state="nameState"
                                            :disabled="!showSaveCoordinatorButton"
                                        />
                                    </b-form-group>

                                    <b-form-group
                                        id="coordinator-email-group"
                                        label="Email:"
                                        label-for="coordinator-email-input"
                                        label-cols-sm="2"
                                        label-align-sm="right"
                                        :invalid-feedback="invalidEmailFeedback"
                                        :state="emailState"
                                        :disabled="!showSaveCoordinatorButton"
                                    >
                                        <b-form-input
                                            id="coordinator-email-input"
                                            v-model="coordinatorEmail"
                                            type="email"
                                            required
                                            placeholder="perkins.coordinator@arkansas.gov"
                                            :state="emailState"
                                            :disabled="!showSaveCoordinatorButton"
                                        />
                                    </b-form-group>
                                    <b-form-group
                                        id="coordinator-phone-group"
                                        label="Telephone:"
                                        label-for="coordinator-phone-input"
                                        label-cols-sm="2"
                                        label-align-sm="right"
                                        :invalid-feedback="invalidPhoneFeedback"
                                        :state="phoneState"
                                        :disabled="!showSaveCoordinatorButton"
                                    >
                                        <b-form-input
                                            id="coordinator-phone-input"
                                            v-model="coordinatorPhone"
                                            type="text"
                                            required
                                            placeholder="XXX-XXX-XXXX"
                                            :state="phoneState"
                                            :disabled="!showSaveCoordinatorButton"
                                        />
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                        </b-card-body>
                    </b-card>
                </b-container>
                <b-container class="mt-2">
                    <b-row align-h="center">
                        <h6>
                            <em>
                                By saving the Coordinator Information,
                                the recipient assures and certifies
                                that the institution will comply with
                                all requirements above.
                            </em>
                        </h6>
                    </b-row>
                    <b-row align-h="between">
                        <b-col class="text-left">
                            <h4 class="text-left">
                                <b-badge v-if="assurancesStatementAgreed"
                                         variant="primary"
                                         class="assurances-stmt"
                                >
                                    <fa-icon fixed-width
                                             :icon="['fal', 'check-circle']"
                                    />
                                    Assurances Statement Agreed
                                </b-badge>
                            </h4>
                        </b-col>

                        <b-col v-if="!formDisabled" class="text-right">
                            <span v-if="!formDisabled && showEditCoordinatorButton">
                                <b-button id="assurances-page-edit-button"
                                          size="sm"
                                          variant="outline-triadic-2"
                                          @click="unlockCoordinatorInfo"
                                >
                                    <fa-icon fixed-width :icon="['fas', 'user-edit']" />
                                    <strong> Edit</strong>
                                </b-button>
                            </span>

                            <span v-if="!formDisabled && showSaveCoordinatorButton">
                                <b-button v-if="isEditingInfo"
                                          variant="outline-secondary"
                                          size="sm"
                                          class="mr-3"
                                          @click="cancelEdit"
                                >
                                    <fa-icon fixed-width :icon="['fal', 'arrow-from-right']" />
                                    <strong>Cancel</strong>
                                </b-button>

                                <b-button id="assurances-page-save-button"
                                          size="sm"
                                          variant="outline-triadic-2"
                                          :disabled="!coordinatorSaveButtonEnabled"
                                          @click="save"
                                >
                                    <fa-icon fixed-width :icon="['fas', 'save']" />
                                    <strong>Save</strong>
                                </b-button>
                            </span>
                        </b-col>
                    </b-row>
                </b-container>
                <!-- <b-form-text v-if="canAgree">
                    Please enter information for the Perkins Coordinator to activate the button and save this page.
                </b-form-text> -->
            </b-form>
        </b-card-body>
    </b-card>
</template>

<script>
// TODO: Extract CoordinatorInfo to a component: lots of validation and enable/disable logic
import { mapState, mapActions, mapGetters } from 'vuex';
import { Log } from '$Shared/@arc/vue-arc';
import PerkinsStatementOfAssurances from './StatementOfAssurances';

export default {
    name: 'AssuranceOfCompliance',

    components: {
        PerkinsStatementOfAssurances
    },

    props: {
        formDisabled: { type: Boolean, default: false },
        applicationId: { type: Number, default: null },
    },

    data() {
        return {
            isSaving: false,
            isEditingInfo: false,
        };
    },

    computed: {
        ...mapState('coverpage', {
            assurancesStatementAgreed: (state) => state.data.content.assurancesStatementAgreed,
            coverpageContent: (state) => state.data.content,
            originalCoordinatorName: (state) => state.original.content.coordinatorName,
            originalCoordinatorEmail: (state) => state.original.content.coordinatorEmail,
            originalCoordinatorPhone: (state) => state.original.content.coordinatorPhone,
        }),

        ...mapGetters({
            hasCoordinatorInfo: 'coverpage/hasCoordinatorInfo',
            hasOriginalCoordinatorInfo: 'coverpage/hasOriginalCoordinatorInfo',
            isApplicant: 'auth/isApplicant'
        }),

        coordinatorName: {
            get() { return this.coverpageContent.coordinatorName; },
            set(value) {
                this.updateContentField({ field: 'coordinatorName', value });
            }
        },

        coordinatorPhone: {
            get() { return this.formatPhone(this.coverpageContent.coordinatorPhone); },
            set(value) {
                this.updateContentField({ field: 'coordinatorPhone', value: value.replace(/[-().\D]/g, '') });
            }
        },

        coordinatorEmail: {
            get() { return this.coverpageContent.coordinatorEmail; },
            set(value) {
                this.updateContentField({ field: 'coordinatorEmail', value });
            }
        },

        showEditCoordinatorButton() {
            return !this.showSaveCoordinatorButton;
        },

        showSaveCoordinatorButton() {
            return (this.isEditingInfo && this.coordinatorFieldsEditable) ||
                (!this.hasOriginalCoordinatorInfo && this.coordinatorFieldsEditable);
        },

        coordinatorSaveButtonEnabled() {
            return this.coordinatorFieldsEditable && this.coordinatorFieldsValid;
        },

        // Allowed to edit and is either the intial entry or has existing data to edit
        coordinatorFieldsEditable() {
            return !this.formDisabled &&
                (this.isFirstEntryOfCoordinatorInfo || this.hasOriginalCoordinatorInfo);
        },

        isFirstEntryOfCoordinatorInfo() {
            return !this.hasOriginalCoordinatorInfo && this.isApplicant;
        },

        isEditOfExistingCoordinatorInfo() {
            return this.hasOriginalCoordinatorInfo && this.isEditingInfo;
        },

        ignoreValidationStates() {
            return !this.showSaveCoordinatorButton;
        },

        nameState() {
            if (this.ignoreValidationStates) { return null; }

            const field = this.coordinatorName;
            const invalidStates = ['null', null, undefined, ''];

            return !invalidStates.includes(field);
        },

        emailState() {
            if (this.ignoreValidationStates) { return null; }

            const field = this.coordinatorEmail;
            const invalidStates = ['null', null, undefined, ''];

            return !invalidStates.includes(field);
        },

        phoneState() {
            if (this.ignoreValidationStates) { return null; }

            const field = this.coordinatorPhone;
            const invalidStates = ['null', null, undefined, ''];
            if (invalidStates.includes(field)) {
                return false;
            }

            if (field && field.replace(/[-().\D]/g, '').length !== 10) {
                return false;
            }

            return true;
        },

        invalidNameFeedback() {
            return 'Please enter both the first and last names of the Perkins Coordinator.';
        },

        invalidEmailFeedback() {
            return 'Please enter the email address of the Perkins Coordinator.';
        },

        invalidPhoneFeedback() {
            return 'Please enter exactly 10 digits for the Perkins Coordinator\'s phone number.' +
                'We\'ll take care of the formatting.';
        },

        coordinatorFieldsValid() {
            return !!(this.nameState && this.emailState && this.phoneState);
        }
    },

    methods: {
        ...mapActions({
            saveCoverPage: 'coverpage/save',
            updateContentField: 'coverpage/updateContentField',
        }),

        async save() {
            this.isSaving = true;
            this.lockCoordinatorInfo();
            try {
                this.agreeToAssurances();

                await this.saveCoverPage(this.applicationId);

                this.isSaving = false;
            } catch (e) {
                Log.error(e, 'COVER PAGE COMPONENT -> Problems saving the Cover Page: ');
                this.isSaving = false;
            }
        },

        agreeToAssurances() {
            // FIXME: This should be an action/mutation combo
            this.$store.commit('coverpage/AGREE_TO_ASSURANCES');
        },

        cancelEdit() {
            if (this.hasOriginalCoordinatorInfo) {
                this.coordinatorName = this.originalCoordinatorName;
                this.coordinatorEmail = this.originalCoordinatorEmail;
                this.coordinatorPhone = this.originalCoordinatorPhone;
            }

            this.lockCoordinatorInfo();
        },

        formatPhone(rawPhoneNumber, $event) {
            const formattedPhone = rawPhoneNumber += '';

            return formattedPhone === ''
                ? null
                : formattedPhone
                    // Remove anything that is not a numeral
                    .replace(/[-().\D]/g, '')
                    // Add dashes between sets of numerals
                    .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        },

        unlockCoordinatorInfo() {
            this.isEditingInfo = true;
        },

        lockCoordinatorInfo() {
            this.isEditingInfo = false;
        }
    }
};
</script>
<style lang="scss" scoped>
    @import '$StyleVars';

    .perkins-coordinator-card {
        color: white;
        font-size: 1.25rem;
        font-weight: bolder;
    }

    .assurances-stmt-not-agreed {
        border-color: $ace-purple;
        color: $ace-purple;
    }

    .assurances-stmt {
        background-color: white;
        color: $ace-purple;
        border-color: $ace-purple;
    }

</style>
